import { render, staticRenderFns } from "./SplitOrderModal.vue?vue&type=template&id=3b95a339&"
import script from "./SplitOrderModal.vue?vue&type=script&lang=js&"
export * from "./SplitOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./SplitOrderModal.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports